import * as config from '@terraframing-suite/rx-config';
import { InputRow } from './InputRow.jsx';
import { PhosphorusPotassiumFieldInputs as Legacy } from './legacy/PhosphorusPotassiumFieldInputs.jsx';
import { SoilDate } from './SoilDate.jsx';
import { ApplicationDate } from './ApplicationDate.jsx';
import { YieldReferenced } from './YieldReferenced.jsx';

export function PhosphorusPotassiumFieldInputs({ nutrient, instance }) {
  const inputs = instance.inputs[nutrient];
  const rx = instance[nutrient];
  const type = nutrient === 'phosphorus' ? 'P' : 'K';

  if (!inputs) return <Legacy nutrient={nutrient} instance={instance} />;

  return (
    <>
      <SoilDate rx={rx} />
      <InputRow
        name={`${type} Product`}
        value={config[nutrient].getProduct(inputs.product, inputs.percentage)}
      />
      <InputRow name={`${type} Groupings (lbs/ac)`} value={inputs.group} />
      <YieldReferenced rx={rx} />
      <InputRow name="Number of Cropping Years" value={inputs.croppingYears} />
      <InputRow name="Years to Critical" value={inputs.yearsToCriticalLevel} />
      <InputRow
        name={`Other ${type} Applications (lbs)`}
        value={inputs.otherApps}
      />
      <ApplicationDate type={type} inputs={inputs} />
    </>
  );
}
